import { render, staticRenderFns } from "./report_abuse_dropdown_item.vue?vue&type=template&id=59e7af4a"
import script from "./report_abuse_dropdown_item.vue?vue&type=script&lang=js"
export * from "./report_abuse_dropdown_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports